export const hhmmToSeconds = (
  value?: string | number | null,
): number | null => {
  if (value == null) return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.max(0, Math.round(value)) : null;
  }
  const trimmed = String(value).trim();
  if (!trimmed) return null;

  if (!trimmed.includes(':')) {
    const asNumber = Number(trimmed);
    return Number.isFinite(asNumber) ? Math.max(0, Math.round(asNumber)) : null;
  }

  const parts = trimmed.split(':');
  const hours = Number(parts[0]) || 0;
  const minutes = Number(parts[1]) || 0;
  const seconds = parts.length >= 3 ? Number(parts[2]) || 0 : 0;
  if ([hours, minutes, seconds].some((n) => Number.isNaN(n))) return null;
  return hours * 3600 + minutes * 60 + seconds;
};

export const secondsToHHmm = (seconds?: number | null): string => {
  if (seconds == null || Number.isNaN(seconds)) return '';
  const total = Math.max(0, Math.round(Number(seconds)));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const secondsToHHmmss = (seconds?: number | null): string => {
  if (seconds == null || Number.isNaN(seconds)) return '';
  const total = Math.max(0, Math.round(Number(seconds)));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};
